;(function () {
  'use strict'

  angular.module('contrast.d3').constant('D3_CONSTANTS', {
    TECH_COLOR_PALETTE: [
      '#31434E',
      '#258CBF',
      '#8FDFFA',
      '#5E4482',
      '#992BA3',
      '#0DA1A9',
      '#3CC3B2',
      '#769A39',
      '#AECD43'
    ],
    CONTAINER_COLOR_PALETTE: [
      '#258CBF',
      '#992BA3',
      '#3CC3B2',
      '#AECD43',
      '#8FDFFA',
      '#5E4482',
      '#0DA1A9',
      '#769A39',
      '#31434E'
    ],
    TIME_FORMATS: {
      MONTH_ABBRV: '%b',
      MONTH_ABBRV_AND_DAY: '%b %e',
      MONTH_NUM_AND_DAY: '%e'
    }
  })
})()
